import {Component, Injector} from '@angular/core';
import {BasePageComponent} from '../../../../base/components/base-page.component';
import {FormBuilder, FormGroup} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {SettingModel} from "../../../models/setting.model";
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-setting-component',
  templateUrl: './setting-component.component.html',
  styleUrls: ['./setting-component.component.scss']
})
export class SettingComponent extends BasePageComponent {
  configForm: FormGroup;
  submitLoading: boolean;
  setterSubscription: Subscription;

  constructor(injector: Injector, private fb: FormBuilder, public translateService: TranslateService) {
    super(injector);
  }

  pageName(): string {
    return 'SettingComponent';
  }

  ngOnInitForChildren(): void {
    this.createForm();
  }

  ngOnDestroyForChildren(): void {
    this.setterSubscription?.unsubscribe()
  }

  createForm() {
    this.configForm = this.configForm ? this.configForm : this.fb.group({});
  }

  onSaveSetting() {
    this.submitLoading = true;
    let settingToSave: SettingModel = this.settingService.setting;
    settingToSave.layout.allAccordionOpen = this.configForm.get('layout').get('accordionsOpen').value || false;
    settingToSave.layout.tabMode = this.configForm.get('layout').get('tabMode').value || false;
    settingToSave.layout.minimizedReview = this.configForm.get('layout').get('minimizedReview').value || false;
    settingToSave.layout.expandedMenu = this.configForm.get('layout').get('expandedMenu').value || false;

    this.setterSubscription?.unsubscribe()
    this.setterSubscription = this.settingService.saveSetting(settingToSave).subscribe((newSetting: SettingModel) => {
      this.submitLoading = false;
      this.closeModal();
    }, (error => {
      this.submitLoading = false;
    }));
  }

  closeModal() {
    this.modalService.hide('setting-modal');
  }
}
